import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineDollarCircle,
    AiOutlineHome
} from 'react-icons/ai'

import {TfiRulerAlt} from "react-icons/tfi";


import {IconContext} from "react-icons";
import {MdOutlineBusinessCenter} from "react-icons/md";
import {RbacAction} from '../../../config/rbac/actions.ts';

// FNP-1935: ids are fixed and readable so an entry is addressable across
// renders, and rbac is an RbacAction so a misspelt action fails to compile.
export type MarketplaceMenuItem = PlatformNavbarMenuItem & {
    id: `nav-${string}`,
    rbac: RbacAction,
};

export const getMenuItems = (): MarketplaceMenuItem[] => {

    return [
        {
            id: 'nav-dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <IconContext.Provider value={{size: '2em'}}><AiOutlineHome/></IconContext.Provider>,
            rbac: 'ViewDashboard',
        },
        {
            id: 'nav-registrations',
            link: '/registrations',
            label: 'Registrations',
            icon: <IconContext.Provider value={{size: '2em'}}><MdOutlineBusinessCenter/></IconContext.Provider>,
            rbac: 'ListRegistrations',
        },
        {
            id: 'nav-offers',
            link: '/offers',
            label: 'Offers',
            icon: <IconContext.Provider value={{size: '2em'}}><AiOutlineDollarCircle/></IconContext.Provider>,
            rbac: 'ListOffers',
        },
        {
            id: 'nav-products',
            link: '/products',
            label: 'Products',
            icon: <IconContext.Provider value={{size: '2em'}}><AiOutlineAppstore/></IconContext.Provider>,
            rbac: 'ListProducts',
        },
        {
            id: 'nav-metering-records',
            link: '/metering-records',
            label: 'Metering Records',
            icon: <IconContext.Provider value={{size: '2em'}}><TfiRulerAlt/></IconContext.Provider>,
            rbac: 'ListMeteringRecords',
        }];

};
